export default {
    API_HOST: process.env.VUE_APP_API_HOST,
    API_PREFIX: process.env.VUE_APP_API_PREFIX,
    LARAVEL_ECHO_HOST: process.env.VUE_APP_LARAVEL_ECHO_HOST,
    WEBSOCKET_PORT: process.env.VUE_APP_WEBSOCKET_PORT,
    WEBSOCKET_SECURE_PORT: process.env.VUE_APP_WEBSOCKET_SECURE_PORT,
    WEBSOCKET_FORCE_TLS: process.env.VUE_APP_WEBSOCKET_FORCE_TLS
};
